import { call, put, select, takeEvery } from 'redux-saga/effects';
import axios from '../axiosConfig';
import { getRateOptionRulesRequest, getRateOptionRulesSuccess } from '../../slices/trip';
import { DiscountEligibility } from '../../../constants';
import formatStateroomsForRequest from '../../../helpers/formatters/formatStateroomsForRequest';

const queryString = require('query-string');

function* getRateOptionRulesWorker({
  payload: {
    itineraryId,
    rateOptionCode,
    key,
    selectedRoomIndex,
    cruiseLineId,
    resultno,
    sessionKey,
  },
}) {
  const { city } = yield select((store) => store.tripSearch.searchObj.cruise.filters);
  const staterooms = yield select((store) => store.tripSearch.searchObj.staterooms);

  const passengerOccupation = (staterooms[selectedRoomIndex].discounts || []).includes(
    DiscountEligibility.OCCUPATION,
  )
    ? staterooms[selectedRoomIndex].passengerOccupation
    : null;

  const request = {
    itineraryId,
    ...formatStateroomsForRequest(staterooms[selectedRoomIndex], cruiseLineId),
    rateOptionCode,
    passengerOccupation,
    passengerCityCode: city ? city.value : null,
    resultno,
    sessionKey,
  };
  try {
    const url = `/cruises/getRateOptionRules?${queryString.stringify(request, { skipNull: true })}`;
    const config = {
      method: 'get',
      url,
    };
    const { data } = yield call(axios, config);
    if (data) {
      yield put(getRateOptionRulesSuccess({ key, rules: data }));
    } else {
      yield put(getRateOptionRulesSuccess({ key, rules: {} }));
    }
  } catch (error) {
    console.error(error);
    yield put(getRateOptionRulesSuccess({ key, rules: {} }));
  }
}

function* getRateOptionRulesWatcher() {
  yield takeEvery(getRateOptionRulesRequest.toString(), getRateOptionRulesWorker);
}

export default getRateOptionRulesWatcher;
